import type { ApiClient } from '@tradeoutlet/shared';

/**
 * The app hands its ApiClient over once at startup (web: lib/api.ts; native: the app entry). Hooks read it here, so
 * screens don't need a provider and tests that import the app's api module get it too.
 */
let client: ApiClient | null = null;
export function configureData(o: { api: ApiClient }) { client = o.api; }
export function dataApi(): ApiClient {
  if (!client) throw new Error('@tradeoutlet/data: call configureData({ api }) first');
  return client;
}
